import { render, staticRenderFns } from "./AdvSearch.vue?vue&type=template&id=fa2ac65e&"
import script from "./AdvSearch.vue?vue&type=script&lang=ts&"
export * from "./AdvSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports